import Color from 'color'
import color from '../shared/color'

export default {
  primary: color.neonPrimary,
  black: color.black,
  white: color.white,
  rental: color.rental,
  dark: Color(color.black).lighten(0.05).toString(),
  light: Color(color.white).darken(0.05).toString()
}
